export enum PnLPage {
  CONFIGURE_SLICE_ALLOCATION_METHODOLOGY_PAGE = 'CONFIGURE_SLICE_ALLOCATION_METHODOLOGY_PAGE',
  CONFIGURE_SLICE_ORDER_PAGE = 'CONFIGURE_SLICE_ORDER_PAGE',
}
